﻿import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListAbfalldatenblatt extends GuiListGeneric {
    constructor() {
        super("Abfalldatenblatt");
    }
}
